
import { Vue, Component } from "vue-property-decorator";
import AIQaEdit from "./components/ai-qa-edit.vue";
import IntelligentQA, {
  AIQaPair,
  IS_DISABLED,
  IS_DISABLED_SEARCH_DICT,
  getIsDisabledLabel,
  getIsDisabledTagType
} from "@/lib/intelligentQA/intelligent-qa";
import AskGoOn from "@/components/ask-go-on.vue";

@Component({
  components: {
    AIQaEdit,
    AskGoOn
  }
})
export default class AIQaOfficerList extends Vue {
  form = {
    isDisabled: 0,
    searchText: "",
    pageNum: 1,
    pageSize: 10
  };
  total = 0;
  loading = false;

  IS_DISABLED_SEARCH_DICT = IS_DISABLED_SEARCH_DICT;
  IS_DISABLED = IS_DISABLED;
  getIsDisabledTagType = getIsDisabledTagType;
  getIsDisabledLabel = getIsDisabledLabel;

  visible = false;
  tableData: any = [];

  confirmShow = false;
  currentConfirm = IS_DISABLED.DISABLE;
  confirmConfig = {
    [IS_DISABLED.DISABLE]: {
      title: "确认停用问题吗？",
      content: "停用后所有使用该问题的面试答疑官都会同步停用，请确认",
      changedStatus: IS_DISABLED.DISABLE // 点击确认后状态更新的值
    },
    [IS_DISABLED.ENABLE]: {
      title: "确认启用问题吗？",
      content: "启用后所有使用该问题的面试答疑官都会同步启用，请确认",
      changedStatus: IS_DISABLED.ENABLE // 点击确认后状态更新的值
    }
  };

  created() {
    this.onSearch();
  }

  onSearch() {
    this.form.pageNum = 1;
    this.getList();
  }

  onCurrentChange(value: number) {
    this.form.pageNum = value;
    this.getList();
  }

  async getList() {
    const res = await IntelligentQA.list(this.form);
    this.total = res.total;
    this.form.pageNum = res.pageNum;
    this.tableData = res.list;
  }

  addQuestion() {
    this.rowData = {} as any;
    this.visible = true;
  }

  rowData = {} as AIQaPair;
  editQuestion(row: any) {
    console.log(row);
    this.rowData = row;
    this.visible = true;
  }

  onDisableStatus(row: any) {
    this.onToggleStatus(row, true);
  }

  onEnableStatus(row: any) {
    this.onToggleStatus(row, false);
  }

  // 提示框 ok
  async onConfirmOk() {
    if (this.loading) return;
    this.loading = true;
    const req = {
      isDisabled: this.confirmConfig[this.currentConfirm].changedStatus,
      qaId: this.rowData.id
    };
    try {
      await IntelligentQA.toggleStatus(req);
      this.$message.success("问题状态更新成功");
      this.onSearch();
    } catch (e) {
      const msg = e?.data?.message || "问题状态更新失败";
      this.$message.error(msg);
    } finally {
      this.loading = false;
      this.rowData = {} as any;
      this.confirmShow = false;
    }
  }

  onToggleStatus(row: any, isDisabled: boolean) {
    isDisabled
      ? (this.currentConfirm = IS_DISABLED.DISABLE)
      : (this.currentConfirm = IS_DISABLED.ENABLE);
    this.rowData = row;
    this.confirmShow = true;
  }
}
